import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { getFileFromUser } from '@weblite/file'
import { PopupMenuItem } from '$common/popup-menu'
import { RemoveIcon } from '$common/icons/remove'
import { EditPhotoIcon } from '$common/icons/edit-photo'
import { uploadImage } from '$func/upload-image'
import { t } from '$i18n'
import { showEditProfileDialog } from '$comp/modals/edit-profile-dialog'
import { ContextMenuList } from '$comp/_app/components/chat/components/body/components/context-menu/components'

interface Props {
  showDelete: boolean
  // NOTE: for deleting image, fileId should be null
  onSubmit: (fileId: string | null) => unknown
  onClose: () => unknown
  xAxis: number
  yAxis: number
}

export function ProfilePictureMenu({
  onClose,
  showDelete,
  onSubmit,
  xAxis,
  yAxis,
}: Props) {
  return (
    <ContextMenuList onClose={onClose} open xAxis={xAxis} yAxis={yAxis}>
      <PopupMenuItem
        text={t(
          `menu.profileImage.${showDelete ? 'replaceImage' : 'newImage'}`,
        )}
        onClick={async () => {
          await onClose()
          await getFileFromUser(
            'image/*',
            file => {
              showEditProfileDialog({
                file: Array.isArray(file) ? file[0] : file,
                onCancel: closeCurrentModal,
                setFile: async (editedFile: File) => {
                  await uploadImage(editedFile, ({ fileId }) => {
                    onSubmit(fileId)
                  })
                  closeCurrentModal()
                },
                onResetCb: onClose,
              })
            },
            false,
          )
        }}
      >
        <EditPhotoIcon />
      </PopupMenuItem>

      {showDelete ? (
        <PopupMenuItem
          text={t('menu.profileImage.deleteCurrent')}
          onClick={async () => {
            await onClose()
            onSubmit(null)
          }}
        >
          <RemoveIcon />
        </PopupMenuItem>
      ) : undefined}
    </ContextMenuList>
  )
}
